
import Navbar from "./components/navbar";
import Hero from './components/hero';
import About from './components/about';
import Services from './components/services';
import Tour from './components/tours';
import Footer from './components/footer';
function App() {
  return (
  <>
  
<Navbar/>
<Hero/>
<About/>
<Services/>
<Tour/>
<Footer/>

    

  

    

    
  </>);
}

export default App;
